const state = {
  list: 1
}

const mutations = {
  setList (state, list) {
    state.list = list
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/dept.js